var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { css } from 'styled-components';
import "../../themes/alert.js";
import { borderRadiusMedium } from "../../themes/borders.js";
import "../../themes/button.js";
import "../../themes/checkbox.js";
import "../../themes/divider.js";
import "../../themes/dropdown.js";
import "../../themes/fieldset.js";
import { fontFamilyBook } from "../../themes/fonts.js";
import "../../themes/input.js";
import "../../themes/list.js";
import "../../themes/listbox.js";
import "../../themes/loader.js";
import "../../themes/option.js";
import "../../themes/popout.js";
import "../../themes/switch.js";
import "../../themes/themes.js";
import "../../themes/tooltip.js";
css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: transparent;\n  border-color: transparent;\n  border-radius: ", "px;\n  border-style: solid;\n  border-width: 1px;\n  box-sizing: border-box;\n  font-family: ", ";\n  font-size: 14px;\n  line-height: 22px;\n  padding: 15px;\n"])), borderRadiusMedium, fontFamilyBook);
/**
 * Get Styled Component popout theme
 * @param options GetPopoutThemeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */
var getPopoutTheme = function getPopoutTheme(options) {
  var look = options.look;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    .bf-popout__arrow {\n      path {\n        fill: ", ";\n      }\n    }\n\n    .bf-popout__dialog-inner {\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n\n    .bf-popout__footer {\n      background-color: ", ";\n      border-top-color: ", ";\n    }\n\n    .bf-popout__header {\n      border-bottom-color: ", ";\n    }\n\n    .bf-popout__heading {\n      color: ", ";\n    }\n  "])), function (_ref) {
    var theme = _ref.theme;
    return theme.popout[look].backgroundColor;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.popout[look].backgroundColor;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.popout[look].borderColor;
  }, function (_ref4) {
    var theme = _ref4.theme;
    return theme.popout[look].textColor;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.popout[look].footerBackgroundColor;
  }, function (_ref6) {
    var theme = _ref6.theme;
    return theme.popout[look].footerBorderColor;
  }, function (_ref7) {
    var theme = _ref7.theme;
    return theme.popout[look].headerBorderColor;
  }, function (_ref8) {
    var theme = _ref8.theme;
    return theme.popout[look].textColor;
  });
};
export { getPopoutTheme };